import { FC, useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';

import { usePercentageOff } from 'dibs-auctions/exports/hooks';

import { PdpSharedAuctionPercentageOff_item$key } from './__generated__/PdpSharedAuctionPercentageOff_item.graphql';

import dibsCss from 'dibs-css';

const itemFragment = graphql`
    fragment PdpSharedAuctionPercentageOff_item on Item {
        ...usePercentageOff_item @arguments(page: pdp)
    }
`;

export const PdpSharedAuctionPercentageOff: FC<{
    item: PdpSharedAuctionPercentageOff_item$key;
    currency: string;
}> = ({ item: itemRef, currency }) => {
    const item = useFragment(itemFragment, itemRef);
    const percentageOff = usePercentageOff({ item, currency });

    useEffect(() => {
        if (percentageOff) {
            trackEvent({
                eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
                interaction_type: interactionTypeConstants.INTERACTION_TYPE_AUCTION_DISCOUNT,
                step_interaction_name: stepInteractionConstants.STEP_INTERACTION_DISPLAY,
            });
        }
    }, [percentageOff]);

    if (!percentageOff) {
        return null;
    }

    return (
        <div className={classnames(dibsCss.sassyFontBodySmall, dibsCss.textAlertsecondary)}>
            <FormattedMessage
                id="PdpSharedAuctionPercentageOff.percentageOff"
                defaultMessage="Starts at {percentageOff}% Off"
                values={{ percentageOff }}
            />
        </div>
    );
};
